import { Component, Input, OnChanges, OnInit } from '@angular/core'
import * as fileSaver from 'file-saver'
import { ChartType } from '../../../shared/enums/chart-type.enum'

import { AggregationDataset } from '../../../shared/interfaces/visualizations/aggregation-dataset.interface'
import { Aggregation } from '../../../shared/interfaces/visualizations/aggregation.interface'

@Component({
  selector: 'app-aggregation-wrapper',
  templateUrl: './aggregation-wrapper.component.html',
  styleUrls: ['./aggregation-wrapper.component.scss']
})
export class AggregationWrapperComponent implements OnChanges {
  @Input() aggregation: Aggregation

  selectedDataset: AggregationDataset
  ChartType = ChartType

  ngOnChanges(): void {
    this.selectedDataset = this.aggregation.datasets[0]
  }

  selectDataset(eventTarget: any): void {
    this.selectedDataset = this.aggregation.datasets.find(
      (d: AggregationDataset) => d.id === eventTarget.value
    )
  }

  downloadDataset(dataset: AggregationDataset): void {
    const blob = new Blob([dataset.csv], {
      type: 'text/csv;charset=utf-8;'
    })
    fileSaver.saveAs(blob, `${this.aggregation.label} - ${dataset.label}.csv`)
  }
}
